<footer class="footer bg-primary">
  <div class="container-fluid">
    <div class="row">
      @if (userService.currentUser(); as user) {
        @if (user.write) {
          <div class="col text-center">
            <a [routerLink]="['/']" class="no-underline">
              <i class="fa-solid fa-home fa-big"></i>
              <div class="small">Accueil</div>
            </a>
          </div>

          <div class="col text-center">
            <a [routerLink]="['/admin', 'person', 'list']" class="no-underline">
              <i class="fa-solid fa-male fa-big"></i>
              <div class="small">Musiciens</div>
            </a>
          </div>

          <div class="col text-center">
            <a [routerLink]="['/admin', 'job']" class="no-underline">
              <i class="fa-solid fa-briefcase fa-big"></i>
              <div class="small">Postes</div>
            </a>
          </div>

          <div class="col text-center">
            <a [routerLink]="['/admin', 'formulas']" class="no-underline">
              <i class="fa-solid fa-tag fa-big"></i>
              <div class="small">Formules</div>
            </a>
          </div>
        }
      }

      <div class="col text-center align-middle">
        <a href="#"
          (click)="logout($event)"
          class="no-underline"
          [attr.aria-label]="'Déconnexion ' + (userService.currentUser()?.username ?? '')">
          <i class="fa-solid fa-right-from-bracket fa-big"></i>
          <div class="small">Déconnexion</div>
      </a>
      </div>
    </div>
  </div>
</footer>
